export default __webpack_public_path__ + "static/media/momos.32a5c3d6.jpg";